import { render, staticRenderFns } from "./FieldWithLabel.vue?vue&type=template&id=72144bf6&scoped=true"
import script from "./FieldWithLabel.vue?vue&type=script&lang=js"
export * from "./FieldWithLabel.vue?vue&type=script&lang=js"
import style0 from "./FieldWithLabel.vue?vue&type=style&index=0&id=72144bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72144bf6",
  null
  
)

export default component.exports